import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import { useIsCampaignTemplateOne } from '~/context/vdp/StaticContext';
import useTrackRendered from '~/hooks/common/telemetry/useTrackRendered';
import useScrollPosition from '~/hooks/vdp/cta/useScrollPosition';
import useShowWhyBuyContent from '~/hooks/vdp/useShowWhyBuyContent';

const EXPERIMENT = 'car-merch-ui-vdp-why-buy-imagery';
const SCROLL_DEPTH = 1700;

export default function useTrackWhyBuyImageryRendered(): void {
  const isCampaignTemplateOne = useIsCampaignTemplateOne();
  const isDealershipPage = useIsDealershipPage();
  const scrollPosition = useScrollPosition();
  const showWhyBuyContent = useShowWhyBuyContent();

  const isWhyBuyRendered =
    showWhyBuyContent && !isCampaignTemplateOne && !isDealershipPage;

  useTrackRendered(
    EXPERIMENT,
    isWhyBuyRendered && scrollPosition >= SCROLL_DEPTH
  );
}
